import React from 'react';
import CurrencyInput from 'react-currency-input-field';

function KrwAmountInput({ value, onValueChange, ...inputProps }) {
  return (
    <CurrencyInput
      {...inputProps}
      type="text"
      inputMode="numeric"
      value={value ?? ''}
      onValueChange={(_rawValue, _name, values) => {
        onValueChange(values?.float ?? null);
      }}
      intlConfig={{ locale: 'ko-KR', style: 'decimal', maximumFractionDigits: 0 }}
      groupSeparator=","
      allowDecimals={false}
      allowNegativeValue={false}
      disableAbbreviations
    />
  );
}

export default KrwAmountInput;
